import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router';

import AppPrivate from '@/AppPrivate.vue';

import Board from '@/modules/board/pages/Index.vue';
import boardRoutes from '@/modules/board/routes';

import Communication from '@/modules/communication/pages/Index.vue';
import communicationRoutes from '@/modules/communication/routes';

// import Customer from '@/modules/customer/pages/Index.vue';
// import customerRoutes from '@/modules/customer/routes';

import Dashboard from '@/modules/dashboard/pages/Index.vue';
import dashboardRoutes from '@/modules/dashboard/routes';

import LogentDashboard from '@/modules/logent-dashboard/pages/Index.vue';
import logentDashboardRoutes from '@/modules/logent-dashboard/routes';

import Pool from '@/modules/pool/pages/Index.vue';
import poolRoutes from '@/modules/pool/routes';

import ErrorPage from '@/modules/error/pages/ErrorPage.vue';

import timeClockRoutes from '@/modules/timeClock/routes';

import { NXT_AUTH_GUARD } from '@nxtpeople/nxt-vue-keycloak';
import { nxtCandidateRoutes } from '@nxtpeople/nxt-styles';
import AUTH_GUARD from './guards/auth.guard';
import { ERROR_GUARD } from './guards/error.guard';
import { SPACE_GUARD } from './guards/space.guard';
import { UNAVAILABLE_GUARD } from './guards/unavailable.guard';

const privateRoutes: Array<RouteRecordRaw> = [
   ...nxtCandidateRoutes,
   {
      path: '',
      redirect: { name: 'board-overview' },
   },
   {
      path: '/board',
      name: 'board',
      component: Board,
      children: boardRoutes,
   },
   {
      path: '/pool',
      name: 'pool',
      component: Pool,
      children: poolRoutes,
   },
   {
      path: '/communication',
      name: 'communication',
      component: Communication,
      children: communicationRoutes,
   },
   // {
   //    path: '/customer',
   //    name: 'customer',
   //    component: Customer,
   //    children: customerRoutes,
   // },
   {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      children: dashboardRoutes,
   },
   {
      path: '/logent-dashboard',
      name: 'logent-dashboard',
      component: LogentDashboard,
      children: logentDashboardRoutes,
   },
   {
      path: '/time-clock',
      name: 'time-clock',
      redirect: { name: 'time-clock-list' },
      component: () => import('@/modules/timeClock/pages/Index.vue'),
      children: timeClockRoutes,
   },
   {
      path: '/bug-report',
      name: 'bug-report',
      component: () => import('@/modules/bugReport/pages/Index.vue'),
   },
];

const publicRoutes: Array<RouteRecordRaw> = [
   {
      path: '/not-found',
      name: 'not-found',
      component: () => import('@/core/pages/NotFound.vue'),
   },
   {
      path: '/unavailable',
      name: 'unavailable',
      component: () => import('@/modules/unavailable/pages/Index.vue'),
   },
   {
      path: '/error',
      name: 'error',
      component: ErrorPage,
   },
];

const router = createRouter({
   history: createWebHistory(import.meta.env.BASE_URL),
   routes: [
      {
         path: '/',
         name: 'AppPrivate',
         component: AppPrivate,
         children: privateRoutes,
         beforeEnter: AUTH_GUARD,
         redirect: { name: 'board-overview' },
      },
      ...publicRoutes,
      {
         path: '/:pathMatch(.*)*',
         name: 'redirect',
         redirect: { name: 'board-overview' },
      },
   ],
});

// check unavailability
router.beforeEach(UNAVAILABLE_GUARD);

// Authentication guard
router.beforeEach((to, from, next) => NXT_AUTH_GUARD(to, from, next, { privateRoutes }));

// other guards
router.beforeEach(SPACE_GUARD);
router.onError(ERROR_GUARD);

export default router;
